/**
 * Formata um valor de string para o padrão de CPF (000.000.000-00).
 */
export const formatCPF = (value: string): string => {
    if (!value) return '';
    return value
        .replace(/\D/g, '')
        .slice(0, 11)
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/**
 * Formata um valor de string para o padrão de Telefone (00) 00000-0000.
 */
export const formatPhone = (value: string): string => {
    if (!value) return '';
    let v = value.replace(/\D/g, '').slice(0, 11);

    if (v.length > 10) {
        // Celular com 9 dígitos (ex: (11) 98888-7777)
        v = v.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    } else if (v.length > 6) {
        // Fixo ou celular com 8 dígitos (ex: (11) 8888-7777)
        v = v.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else if (v.length > 2) {
        v = v.replace(/^(\d{2})(\d+)$/, '($1) $2');
    } else if (v.length > 0) {
        v = v.replace(/^(\d{2})$/, '($1)');
    }
    return v;
};

/**
 * Formata a string para a primeira letra de cada palavra ser maíuscula.
 */
export const capitalizeWords = (str: string | null | undefined): string => {
    if (!str) {
        return '';
    }

    return str
        .toLowerCase()
        .split(' ')
        .map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(' ');
};

/**
 * Formata data para evitar erros com fuso horário.
 */
export const formatData = (data: string | null) => {
    if (!data) return "";

    const dateObj = new Date(data);

    if (isNaN(dateObj.getTime())) {
        return "";
    }

    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    };

    return new Intl.DateTimeFormat('pt-BR', options).format(dateObj);
};
